// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDmPh79-vu85tvbi-mamiX9H2RV4UHBO14",
    authDomain: "encasa-app.firebaseapp.com",
    databaseURL: "https://encasa-app.firebaseio.com",
    projectId: "encasa-app",
    storageBucket: "encasa-app.appspot.com",
    messagingSenderId: "509110043646",
    appId: "1:509110043646:web:66024ded87f2c69880b6af",
    measurementId: "G-BCNSGMXM2J"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
